var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"10","width":"10","viewBox":"0 0 10 10"}},[_c('circle',{attrs:{"cx":"5","cy":"5","r":"5","stroke-width":".5","fill":_vm.fillColor}})])}
var staticRenderFns = []

export { render, staticRenderFns }